"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventAction = exports.TealiumComponent = exports.TealiumFormat = exports.TealiumAction = exports.PAGE_NAME_BANNER = exports.CROSSELL_MODULE_OPEN = exports.CROSSELL_MODULE_VIEW = void 0;
exports.CROSSELL_MODULE_VIEW = 'CROSSELL_MODULE_VIEW';
exports.CROSSELL_MODULE_OPEN = 'CROSSELL_MODULE_OPEN';
exports.PAGE_NAME_BANNER = 'accountOverview';
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["OPEN"] = "open";
    TealiumAction["VIEW"] = "view";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["BANNER"] = "banner";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["CROSSELL_MODULE"] = "crossellModule";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["VIEW_BANNER"] = "viewBanner";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
//# sourceMappingURL=actions.js.map